module.exports = __webpack_public_path__ + "img/gropius_house.be57215e.jpg";